import SetupGameModal from './setupModals/SetupGameModal';
import SetupGames from './setupGames/SetupGames';
import { Alert, Button, Col, Container, Figure, Row } from 'react-bootstrap';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SettingsIcon from '../../images/settings.png';

function Setup() {
    const { t } = useTranslation();
    const [showSetupModal, setShowSetupModal] = useState(true);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const grid: string[][] = [
        ['1.MD', '2.MD'],
        ['WD', 'XD'],
        ['WS', '1.MS'],
        ['2.MS', '3.MS'],
    ];

    const saveErrorMessage = (message: string) => {
        setAlertMessage(message);
        setShowAlert(true);
    };

    return (
        <>
            <Alert variant={'warning'} show={showAlert} onClose={() => setShowAlert(false)} dismissible={true}>
                {alertMessage}
            </Alert>
            <SetupGameModal show={showSetupModal} onClose={() => setShowSetupModal(false)} />
            <Container fluid>
                <div style={{ width: '100%' }}>
                    <div style={{ width: '100%', marginTop: '10px' }}>
                        <h4 style={{ textAlign: 'center' }}>{t('setup.title')}</h4>
                        <div style={{ textAlign: 'end' }}>
                            <Button variant="light" onClick={() => setShowSetupModal(true)}>
                                <Figure>
                                    <Figure.Image width={64} height={64} src={SettingsIcon} />
                                    <Figure.Caption>{t('setup.settings')}</Figure.Caption>
                                </Figure>
                            </Button>
                        </div>
                    </div>
                    {grid.map((modes) => (
                        <Row key={`row-${modes.map((m) => m).join('-')}`}>
                            {modes.map((mode) => (
                                <Col key={`col-${mode}`}>
                                    <SetupGames game={mode} saveErrorMessage={saveErrorMessage} />
                                </Col>
                            ))}
                        </Row>
                    ))}
                </div>
            </Container>
        </>
    );
}

export default Setup;
